import { orderType } from '../../types/order/orderType';
import { request } from '../../utils/request';

type ReturnType = {
  store_id: string;
  filters: {
    product_id?: string;
    status?: string;
  };
  orders: Array<orderType>;
};

export const getOrders = (
  store_id: number,
  authToken: string,
  filters?: ReturnType['filters']
): Promise<ReturnType> => {
  const params = new URLSearchParams({
    storeId: `${store_id}`,
    ...filters,
  });

  return request({
    method: 'GET',
    url: `/payments/products/orders?${params.toString()}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
